import { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { TextField, TextFieldType, Typography } from '@cfa/react-components';

import Constants from '@/constants';

interface EditTaskProps {
  error: string;
  onEdit: () => void;
  setTask: (task: EditTaskProps['task']) => void;
  task: { name: string; note: string; url: string };
}

const EditTask: React.FC<EditTaskProps> = ({
  error,
  onEdit,
  setTask,
  task,
}) => {
  const { t } = useTranslation();
  const nameRef = useRef<TextFieldType>(null);
  const notesRef = useRef<TextFieldType>(null);
  const linkRef = useRef<TextFieldType>(null);

  return (
    <div className={'w-full'}>
      <Typography variant="overline3">
        {t('Generic.task')} <span className="text-feedback-error-base">*</span>
      </Typography>
      <TextField
        className={'mb-4'}
        data-testid="EditTaskName"
        fullWidth
        maxLength={Constants.FORMS.MAX_TASK_LENGTH}
        multiline
        onChange={e => setTask({ ...task, name: e.target.value })}
        onKeyDown={e => e.key === 'Enter' && notesRef.current?.focus()}
        placeholder={t('TrainingPlans.addTaskFormPlaceholderText.task')}
        ref={nameRef}
        rows={1}
        value={task.name}
      />
      <Typography variant="overline3">{t('Generic.notes')}</Typography>
      <TextField
        className={'mb-4'}
        data-testid="EditNotes"
        fullWidth
        multiline
        onChange={e => setTask({ ...task, note: e.target.value })}
        onKeyDown={e => e.key === 'Enter' && linkRef.current?.focus()}
        placeholder={t('TrainingPlans.addTaskFormPlaceholderText.notes')}
        ref={notesRef}
        rows={1}
        value={task.note}
      />
      <Typography variant="overline3">{t('Generic.url')}</Typography>
      <TextField
        className={'mb-4'}
        data-testid="EditTaskUrl"
        // @ts-expect-error (overload error, we can ignore for now)
        error={error}
        errorText={error}
        fullWidth
        onChange={e => setTask({ ...task, url: e.target.value })}
        onKeyDown={e =>
          e.key === 'Enter' && task.name.trim().length > 0 && onEdit()
        }
        placeholder={t('TrainingPlans.addTaskFormPlaceholderText.link')}
        ref={linkRef}
        value={task.url}
      />
    </div>
  );
};

export default EditTask;
